import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcListWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.33325 7.3C4.33325 6.58203 4.91528 6 5.63325 6H22.3666C23.0846 6 23.6666 6.58203 23.6666 7.3V8.03333C23.6666 8.7513 23.0846 9.33333 22.3666 9.33333H5.63325C4.91528 9.33333 4.33325 8.7513 4.33325 8.03333V7.3Z",
			fill: "#C4D7FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.33325 13.6334C4.33325 12.9154 4.91528 12.3334 5.63325 12.3334H22.3666C23.0846 12.3334 23.6666 12.9154 23.6666 13.6334V14.3667C23.6666 15.0847 23.0846 15.6667 22.3666 15.6667H5.63325C4.91528 15.6667 4.33325 15.0847 4.33325 14.3667V13.6334Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.33325 19.9666C4.33325 19.2487 4.91528 18.6666 5.63325 18.6666H17.6999C18.4179 18.6666 18.9999 19.2487 18.9999 19.9666V20.7C18.9999 21.4179 18.4179 22 17.6999 22H5.63325C4.91528 22 4.33325 21.4179 4.33325 20.7V19.9666Z",
			fill: "#E2EBFE"
		})
	]
});
export default SvgIcListWhite;
